// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyC6hN90glFf551ZguYAWqI1miekFbd-pOE",
    authDomain: "media-art-db5b9.firebaseapp.com",
    projectId: "media-art-db5b9",
    storageBucket: "media-art-db5b9.firebasestorage.app",
    messagingSenderId: "1059856061034",
    appId: "1:1059856061034:web:53ed6ec46d1f3e25087013",
    measurementId: "G-XV7DZL7EVG"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export default db;
